"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.STRING_TRANSLATIONS = void 0;
const concat_1 = require("./concat");
const find_1 = require("./find");
const isBlank_1 = require("./isBlank");
const left_1 = require("./left");
const len_1 = require("./len");
const lower_1 = require("./lower");
const mid_1 = require("./mid");
const regex_replace_1 = require("./regex.replace");
const right_1 = require("./right");
const substitute_1 = require("./substitute");
const substitutes_1 = require("./substitutes");
const trim_1 = require("./trim");
const upper_1 = require("./upper");
const regex_extract_1 = require("./regex.extract");
const padleft_1 = require("./padleft");
const padright_1 = require("./padright");
const json_extract_1 = require("./json.extract");
const removeDiacritics_1 = require("./removeDiacritics");
const split_1 = require("./split");
const proper_1 = require("./proper");
const text_1 = require("./text");
__exportStar(require("./concat"), exports);
__exportStar(require("./regex.replace"), exports);
__exportStar(require("./regex.extract"), exports);
__exportStar(require("./substitute"), exports);
__exportStar(require("./substitutes"), exports);
__exportStar(require("./mid"), exports);
__exportStar(require("./split"), exports);
exports.STRING_TRANSLATIONS = {
    CONCAT: concat_1.CONCAT,
    REGEX_REPLACE: regex_replace_1.REGEX_REPLACE,
    REGEX_EXTRACT: regex_extract_1.REGEX_EXTRACT,
    SUBSTITUTE: substitute_1.SUBSTITUTE,
    SUBSTITUTES: substitutes_1.SUBSTITUTES,
    TRIM: trim_1.TRIM,
    RIGHT: right_1.RIGHT,
    LEFT: left_1.LEFT,
    UPPER: upper_1.UPPER,
    LOWER: lower_1.LOWER,
    PROPER: proper_1.PROPER,
    TEXT: text_1.TEXT,
    LEN: len_1.LEN,
    ISBLANK: isBlank_1.ISBLANK,
    FIND: find_1.FIND,
    MID: mid_1.MID,
    PADLEFT: padleft_1.PADLEFT,
    PADRIGHT: padright_1.PADRIGHT,
    JSON_EXTRACT: json_extract_1.JSON_EXTRACT,
    REMOVE_DIACRITICS: removeDiacritics_1.REMOVE_DIACRITICS,
    SPLIT: split_1.SPLIT,
};
